import {
  CREATE_REGISTRATION_FORM_REQUEST,
  CREATE_REGISTRATION_FORM_SUCCESS,
  CREATE_REGISTRATION_FORM_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
};

const createRegistrationFormReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case CREATE_REGISTRATION_FORM_REQUEST:
      return { ...state, loading: true };
    case CREATE_REGISTRATION_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_REGISTRATION_FORM_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default createRegistrationFormReducer;
